import { IDropdownStyles } from "@fluentui/react";

const mainColor = "#cc214F"


export const dropdownStylesSingle = (theme: string) :Partial<IDropdownStyles>  => {

    return {
        caretDown:
        {
            color: "black",
            fontSize: "10px",
            fontWeight: 700,
        },
        dropdownItems:
        {
            borderColor: "transparent",
            fontWeight: 500,
            fontSize: "12px",
        },
        title:
        {
            color: theme !== "light" ? "white !important" : `black !important`,
            borderColor: "transparent !important",
            borderRadius: "15px !important",
            border: `solid 1px ${mainColor} !important`,
            fontWeight: 500,
            fontSize: "12px",
        },
        dropdownItemSelected:
        {
            backgroundColor: mainColor,
        },
        dropdownOptionText: { 
            color: theme !== "light" ? "white !important" : `black !important` ,
        },
        dropdown: {
            justifyContent: "center",
            padding: "0 !important",
            selectors: {        
                '&:focus:after': {
                border: "none",
                },
            }

        },
        callout: {
            width: 200,
        }
    };
};

export const dropdownStylesCell = (theme: string) : Partial<IDropdownStyles> => {
    return {
        caretDown: 
        {
            color: "black",
            fontSize: "10px",
            fontWeight: 700,
        },
        dropdownItems:
        {
            borderColor: "transparent",
            fontWeight: 500,
            fontSize: "12px",
            width: "170px !important",
        },
        title:
        {
            color: theme !== "light" ? "white !important" : `black !important` ,
            fontWeight: 500,
            fontSize: "12px",
        },
        dropdownItemSelected:
        {
            backgroundColor: mainColor,
        },
        dropdownOptionText: { 
            color: theme !== "light" ? "white !important" : `black !important` ,
        },
        dropdown: {
            justifyContent: "center",
            padding: "0 !important",
            cursor: "pointer",

        },
    };
};